import { call, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';

export let numberOfTarifierungInProgress = 0;

export function* isTarifierungActive() {
  yield takeEvery(
    GlobalActions.TARIFIERUNG_HAS_STARTED,
    safeSaga(addOneTarifierungToQueue, App.SHOP),
  );
  yield takeEvery(
    GlobalActions.TARIFIERUNG_HAS_ENDED,
    safeSaga(subtractOneTarifierungFromQueue, App.SHOP),
  );
  yield takeEvery(
    GlobalActions.TARIFIERUNG_CANCELED,
    safeSaga(subtractOneTarifierungFromQueue, App.SHOP),
  );
  yield takeEvery(
    GlobalActions.TARIFIERUNG_RUN_RELEASED,
    safeSaga(subtractOneTarifierungFromQueue, App.SHOP),
  );
}

export function addOneTarifierungToQueue(): void {
  numberOfTarifierungInProgress++;
}

export function* subtractOneTarifierungFromQueue() {
  numberOfTarifierungInProgress--;
  if (numberOfTarifierungInProgress === 0) {
    const globalPut = GlobalPut.getInstance();
    yield call([globalPut, globalPut.put], new GlobalActions().allTarifierungenHaveEnded());
  } else if (numberOfTarifierungInProgress < 0) {
    resetNumberOfTarifierungenInProgress();
  }
}

export function resetNumberOfTarifierungenInProgress(): void {
  numberOfTarifierungInProgress = 0;
}
